export class AuditLog {
  constructor({
    id = 0,
    entityType = null,
    auditDate = null,
    auditData = null,
    auditUser = null,
  } = {}) {
    this.id = id;
    this.entityType = entityType;
    this.auditData = auditData;
    this.auditDate = auditDate;
    this.auditUser = auditUser;
  }
}
export function createAuditLog(data) {
  return Object.freeze(new AuditLog(data));
}
